import request from '../helpers'

const state = {
  loading: false,
  setting: {
    activeCause: {
      name: 'Truck Tracking',
      localizations: [{
        logoUrl:""
      }]
    }
  },
  
    baseApi:"https://localhost:5001/api/"
  
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  UPDATE_SETTINGS(state, settings) {
    state.settings = settings
  },
  UPDATE_ACTIVE_CAUSE(state, cause) {
    if (state.settings.activeCause.id == cause.id) {
      state.settings.activeCause.name = cause.name
      state.settings.activeCause.localizations = cause.localizations
    }
  },
  UPDATE_ACTIVE_CAUSE_NO_VOTES(state, votes) {
    state.settings.activeCause.numberOfVotes = votes
  },
  UPDATE_APP_ACTIVE(state, active) {
    state.settings.isAppActive = active
  }
}

const actions = {
  getSettings({ commit }) {
    return request({ method: 'get', url: 'settings/', successCallback: settings => {
      commit('UPDATE_SETTINGS', settings);
    }});
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}